var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconData = function SvgIconData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 500 500",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_data_svg2__a",
    x1: 90.36,
    x2: 476.69,
    y1: 470.95,
    y2: 150.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_data_svg2__a",
    id: "icon_data_svg2__b",
    x1: 90.22,
    x2: 476.56,
    y1: 470.79,
    y2: 150.64
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_data_svg2__a",
    id: "icon_data_svg2__c",
    x1: 10.57,
    x2: 396.9,
    y1: 374.68,
    y2: 54.52
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_data_svg2__a",
    id: "icon_data_svg2__d",
    x1: 170.09,
    x2: 556.42,
    y1: 567.16,
    y2: 247.01
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_data_svg2__a",
    id: "icon_data_svg2__e",
    x1: 19.59,
    x2: 405.92,
    y1: 385.55,
    y2: 65.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_data_svg2__a",
    id: "icon_data_svg2__f",
    x1: -14.79,
    x2: 371.54,
    y1: 344.07,
    y2: 23.91
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_data_svg2__a",
    id: "icon_data_svg2__g",
    x1: 19.43,
    x2: 405.76,
    y1: 385.37,
    y2: 65.21
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_data_svg2__a",
    id: "icon_data_svg2__h",
    x1: -16.73,
    x2: 369.61,
    y1: 341.74,
    y2: 21.58
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M250 284.01c-30.18 0-54.65 24.47-54.65 54.65s24.47 54.65 54.65 54.65 54.64-24.45 54.65-54.63c-.02-30.18-24.47-54.64-54.65-54.67m0 95.53c-22.58 0-40.89-18.31-40.89-40.89s18.31-40.89 40.89-40.89 40.89 18.31 40.89 40.89v.03c-.04 22.56-18.33 40.83-40.89 40.86",
    style: {
      fill: "url(#icon_data_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347.84 402.94-15.83-19.78a93 93 0 0 0 7.8-19.27l24.99-2.77a6.884 6.884 0 0 0 6.12-6.84V321.6c0-3.51-2.63-6.45-6.12-6.84l-25.38-2.81a94 94 0 0 0-7.8-18.46l15.7-19.61a6.91 6.91 0 0 0-.51-9.17L323.7 241.6a6.875 6.875 0 0 0-9.16-.51l-19.61 15.7a99.6 99.6 0 0 0-18.94-7.73l-2.81-25.21c-.39-3.48-3.34-6.11-6.84-6.12h-32.68c-3.51 0-6.45 2.64-6.84 6.13l-2.8 25.2a92.3 92.3 0 0 0-19.16 7.98l-19.92-15.96a6.89 6.89 0 0 0-9.17.51l-23.1 23.11a6.89 6.89 0 0 0-.51 9.17l15.99 19.97a90.2 90.2 0 0 0-7.8 18.84l-25.18 2.81a6.884 6.884 0 0 0-6.12 6.84v32.68c0 3.5 2.63 6.45 6.12 6.83l25.18 2.81a89 89 0 0 0 7.8 18.84l-15.99 19.98a6.89 6.89 0 0 0 .51 9.17l23.1 23.1a6.91 6.91 0 0 0 9.17.51l19.91-15.93c6.07 3.37 12.5 6.05 19.17 7.98l2.8 25.19a6.885 6.885 0 0 0 6.84 6.13h32.68c3.51 0 6.45-2.64 6.84-6.13l2.81-25.19c6.8-1.97 13.35-4.72 19.53-8.18l19.54 15.6a6.89 6.89 0 0 0 9.17-.51l23.1-23.1a6.884 6.884 0 0 0 .51-9.15Zm-29 18.17-16.37-13.1-.76-.9a6.9 6.9 0 0 0-8.98-1.39 78.6 78.6 0 0 1-24.84 10.43 6.886 6.886 0 0 0-5.35 6.68l-2.35 22.96h-20.37l-2.35-21.16v-1.82a6.866 6.866 0 0 0-5.38-6.68l-.69-.17a79 79 0 0 1-23.53-9.87 6.84 6.84 0 0 0-8.02.52l-18.69 15.04-14.4-14.4 13.61-17.02 1.54-1.99a6.91 6.91 0 0 0 .39-7.8 76.6 76.6 0 0 1-9.7-23.39 6.85 6.85 0 0 0-5.37-5.21l-2.29-.46c-.19-.04-.38-.07-.58-.09l-21.53-2.39v-20.42l21.9-2.45 2.28-.38a6.87 6.87 0 0 0 5.57-5.25c1.91-8.32 5.2-16.27 9.74-23.5a6.91 6.91 0 0 0-.41-7.8l-15.14-18.94 14.4-14.4 16.71 13.37 1.86 1.58a6.88 6.88 0 0 0 8.41.39l.43-.31c7.26-4.44 15.2-7.67 23.49-9.58a6.875 6.875 0 0 0 5.35-6.68l2.36-22.97h20.37l2.35 21.16v1.82c.01 3.2 2.23 5.97 5.35 6.68a83.7 83.7 0 0 1 24.23 9.85 6.885 6.885 0 0 0 8.21-.78l18.01-14.55 14.4 14.4-13.53 16.92-.1.12-1.34 1.77a7.16 7.16 0 0 0 .19 8.44 78.4 78.4 0 0 1 9.39 22.76 6.876 6.876 0 0 0 6.58 5.28l23.25 2.39v20.36l-21.37 2.32-2.07.2a6.87 6.87 0 0 0-6.06 5.35 78.5 78.5 0 0 1-9.93 24.36 6.865 6.865 0 0 0 1.05 8.53l14.48 17.82z",
    style: {
      fill: "url(#icon_data_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.02 338.68c0-3.8-3.09-6.87-6.88-6.87H7.16c-3.8-.15-7 2.8-7.16 6.6-.15 3.8 2.8 7 6.6 7.16h94.57c3.78-.02 6.84-3.1 6.84-6.88Z",
    style: {
      fill: "url(#icon_data_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.84 331.77h-94.02c-3.8-.15-7 2.8-7.16 6.6-.15 3.8 2.8 7 6.6 7.16h94.57c3.8.15 7-2.8 7.16-6.6.15-3.8-2.8-7-6.6-7.16z",
    style: {
      fill: "url(#icon_data_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.1 311.56c3.8 0 6.88-3.07 6.88-6.86V100.83h211.44v52.03c0 3.8 3.09 6.87 6.88 6.87h51.72v144.95c.15 3.8 3.36 6.75 7.16 6.6a6.88 6.88 0 0 0 6.6-6.6V152.74c.01-.16.01-.33 0-.49v-.36c0-.12 0-.2-.06-.3s-.06-.27-.09-.4l-.07-.26c0-.13-.09-.27-.14-.4-.02-.08-.05-.15-.08-.22-.06-.13-.12-.27-.18-.39-.03-.08-.07-.15-.11-.22-.07-.13-.14-.26-.22-.39s-.08-.12-.12-.19c-.09-.14-.19-.28-.3-.41a.6.6 0 0 0-.1-.13 5 5 0 0 0-.48-.53l-58.65-58.88c-.17-.17-.35-.32-.52-.48h-.08c-.14-.12-.3-.23-.46-.33l-.2-.12-.38-.23-.22-.1-.39-.18-.22-.09-.41-.14h-.23c-.13 0-.27-.08-.41-.1h-174.4V54.19H430.3v203.85c.15 3.8 3.36 6.75 7.16 6.6a6.88 6.88 0 0 0 6.6-6.6V47.29c0-3.8-3.08-6.88-6.88-6.88H153.37c-3.8 0-6.87 3.09-6.87 6.88v39.85h-38.4c-3.8 0-6.87 3.08-6.87 6.87v210.68c0 3.8 3.08 6.87 6.87 6.87m232.13-200.88 35.17 35.36h-35.17z",
    style: {
      fill: "url(#icon_data_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.77 142.26H150.53c-3.8.15-6.75 3.36-6.6 7.16a6.88 6.88 0 0 0 6.6 6.6h139.24c3.8.15 7-2.8 7.16-6.6.15-3.8-2.8-7-6.6-7.16h-.55Z",
    style: {
      fill: "url(#icon_data_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.77 182.6h-67.89c-3.8-.15-7 2.8-7.16 6.6-.15 3.8 2.8 7 6.6 7.16h68.44c3.8.15 7-2.8 7.16-6.6.15-3.8-2.8-7-6.6-7.16z",
    style: {
      fill: "url(#icon_data_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 182.6c-3.8.15-6.75 3.36-6.6 7.16a6.88 6.88 0 0 0 6.6 6.6h32.5c3.8.15 7-2.8 7.16-6.6.15-3.8-2.8-7-6.6-7.16h-33.05Z",
    style: {
      fill: "url(#icon_data_svg2__h)"
    }
  }));
};
export default SvgIconData;